var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("编辑角色")]),_c('basis-form',{ref:"basis"}),_c('a-row',[_c('a-col',_vm._b({},'a-col',_vm.$formItemLayoutWithoutLabel.wrapperCol,false),[_c('a-button',{staticStyle:{"width":"160px"},attrs:{"type":"primary","shape":"round"},on:{"click":_vm.onSubmit}},[_vm._v(" 确认 ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }